import React from "react"
import {Box, Typography} from "@mui/material"
import {packagingTokens as tk} from "@/theme/packagingTokens"

type PageHeaderProps = {
    title: string
    subtitle?: React.ReactNode
    actions?: React.ReactNode
}

// The Rémi page header: title (24/700, tight tracking) + optional secondary
// subtitle, with optional right-aligned actions. Shared across packaging-v3 views.
export default function PageHeader(props: PageHeaderProps) {
    const {title, subtitle, actions} = props
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
                gap: 2,
                flexWrap: "wrap",
                mb: 3.5,
            }}
        >
            <Box>
                <Typography
                    component={"h1"}
                    sx={{
                        fontSize: "24px",
                        fontWeight: 700,
                        letterSpacing: "-0.02em",
                        color: tk.color.textPrimary,
                    }}
                >
                    {title}
                </Typography>
                {subtitle && (
                    <Typography
                        sx={{fontSize: "14px", color: tk.color.textSecondary, mt: 0.5}}
                    >
                        {subtitle}
                    </Typography>
                )}
            </Box>
            {actions && <Box sx={{display: "flex", gap: 1, flexWrap: "wrap"}}>{actions}</Box>}
        </Box>
    )
}
